import { Database } from "types/supabase";
import { supabaseClient } from "supabase";
import { deleteImage, uploadImage } from "supabase/files";

export type UpdateVenueParams = {
  id: Database["public"]["Tables"]["venues"]["Row"]["id"];
  uid: Database["public"]["Tables"]["venues"]["Row"]["uid"];
  name: Database["public"]["Tables"]["venues"]["Row"]["name"];
  address: Database["public"]["Tables"]["venues"]["Row"]["address"];
  city: Database["public"]["Tables"]["venues"]["Row"]["city"];
  city_id: Database["public"]["Tables"]["venues"]["Row"]["city_id"];
  phone: Database["public"]["Tables"]["venues"]["Row"]["phone"];
  website: Database["public"]["Tables"]["venues"]["Row"]["website"];
  description: Database["public"]["Tables"]["venues"]["Row"]["description"];
  description_pt: Database["public"]["Tables"]["venues"]["Row"]["description_pt"];
  currPicture: Database["public"]["Tables"]["venues"]["Row"]["picture"];
  newPicture?: File;
  location_lat: Database["public"]["Tables"]["venues"]["Row"]["location_lat"];
  location_long: Database["public"]["Tables"]["venues"]["Row"]["location_long"];
};

export const updateVenue = async ({
  id,
  uid,
  name,
  address,
  city,
  city_id,
  phone,
  website,
  description,
  description_pt,
  currPicture,
  newPicture,
  location_lat,
  location_long,
}: UpdateVenueParams) => {
  let picturePath = null;

  if (newPicture) {
    picturePath = await uploadImage(
      newPicture,
      `${Date.now()}.${newPicture.type.split("/")[1]}`,
      "venues",
      uid!
    );
    if (currPicture) {
      deleteImage(currPicture!.split("/").slice(-2).join("/"), "venues");
    }
  }

  const updatedVenue = {
    name,
    address,
    city,
    city_id,
    phone,
    website,
    description,
    description_pt,
    picture: currPicture,
    location_lat,
    location_long,
  };

  if (picturePath) {
    updatedVenue.picture = picturePath;
  }

  const { error } = await supabaseClient
    .from("venues")
    .update(updatedVenue)
    .eq("id", id);

  if (error) {
    throw error;
  }

  return updatedVenue;
};
